import React from 'react';
import cx from 'classnames';
import Paragraph from "@scentregroup/ui/components/paragraph";
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const NonReturnableText = _ref => {
  let {
    returnable,
    wrapperClassname,
    labelClassname
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: returnable === false && /*#__PURE__*/_jsx("div", {
      "aria-live": "polite",
      className: wrapperClassname,
      "data-id": "non-returnable-text_index_NonReturnableText_div",
      children: /*#__PURE__*/_jsx(Paragraph, {
        type: "small",
        className: cx(style.nonReturnableText, labelClassname),
        "data-id": "non-returnable-text_index_NonReturnableText_div_Paragraph",
        children: "This item cannot be returned unless faulty"
      })
    })
  });
};

export default NonReturnableText;